import React, { Fragment, useState, useEffect } from 'react';
import { DndProvider } from 'react-dnd';

import Checkbox from '../../../common/Checkbox';
import TableDekstopItem from './TableDekstopItem';

import Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const rowProps = [
  { prop: 'weight', title: 'Вес', tableTitle: 'Вес (кг)' },
  { prop: 'price', title: 'Цена' },
  { prop: 'article', title: 'Артикул' },
  { prop: 'barcodes', title: 'Штрихкод' },
];

const VariantsTableBody = (props) => {
  const {
    features,
    variants,
    variantsValidation,
    selectedVariants,
    handleSelectVariant,
    updateVariant,
    deleteVariant,
    deleteLoading,
    openVariant,
    dispatch,
    moveVariant,
  } = props;

  const [hoveredRow, setHoveredRow] = useState(null);
  const [variantsValues, setVariantsValues] = useState({});

  let newVariants = [];

  useEffect(() => {
    //! Проверить отображаются ли МК в таблице варианта - не должны по идее после filter
    newVariants = variants
      .filter((v) => !v.parentPackageId)
      .sort((a, b) => {
        return a.ordering - b.ordering;
      });
    generateVariantsValues();
  }, [variants]);

  const generateVariantsValues = () => {
    const newValues = {};
    newVariants.forEach((v) => {
      const vId = v.temporaryId ? v.temporaryId : v.id;
      newValues[vId] = {};
      rowProps.forEach((p) => {
        switch (p.prop) {
          case 'width':
          case 'height':
          case 'depth':
            newValues[vId][p.prop] = v.dimensions ? v.dimensions[p.prop] : undefined;
            break;
          case 'barcodes':
            if (v.barcodes && v.barcodes.length) {
              const findDefault = v.barcodes.find((b) => b.isDefault);
              if (findDefault) {
                newValues[vId][p.prop] = findDefault.value;
              } else {
                newValues[vId][p.prop] = v.barcodes[0].value;
              }
            } else {
              newValues[vId][p.prop] = '';
            }
            break;
          default:
            newValues[vId][p.prop] = v[p.prop];
        }
      });
    });

    setVariantsValues(newValues);
  };

  const handleMouseLeave = () => {
    //generateVariantsValues();
    setHoveredRow(null);
  };

  const moveFilter = (dragIndex, hoverIndex) => {
    const dragCard = variants.find((item, i) => i === dragIndex);
    moveVariant(
      update(variants, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragCard],
        ],
      }),
    );
  };

  const rows = variants.map((item, i) => (
    <TableDekstopItem
      key={item.id}
      item={item}
      index={i}
      features={features}
      setHoveredRow={setHoveredRow}
      handleMouseLeave={handleMouseLeave}
      handleSelectVariant={handleSelectVariant}
      selectedVariants={selectedVariants}
      openVariant={openVariant}
      variantsValues={variantsValues}
      rowProps={rowProps}
      hoveredRow={hoveredRow}
      variantsValidation={variantsValidation}
      updateVariant={updateVariant}
      variants={variants}
      deleteLoading={deleteLoading}
      deleteVariant={deleteVariant}
      moveFilter={moveFilter}
      i={i}
    />
  ));

  return (
    <DndProvider backend={Backend}>
      <tbody>{rows}</tbody>
    </DndProvider>
  );
};

const VariantsTable = (props) => {
  const { allSelectedVariants, handleAllSelectVariants } = props;

  const { t } = useAutoTranslation();

  return (
    <Fragment>
      <div className="row" style={{ marginTop: '25px' }}>
        <div className="col-12">
          <div className="bootstrap-table">
            <div className="fixed-table-container variants-table">
              <div className="fixed-table-body">
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th
                        style={{ width: '20px' }}
                        className="checkbox-td"
                        onClick={handleAllSelectVariants}
                      >
                        <Checkbox id={`checkbox-all`} checked={allSelectedVariants} />
                      </th>
                      <th style={{ width: '76px' }}></th>
                      <th>{t('Вариант')}</th>
                      <Fragment>
                        {rowProps.map((p) => (
                          <th>{p.tableTitle ? t(p.tableTitle) : t(p.title)}</th>
                        ))}
                      </Fragment>
                      <th>{t('Доступно')}</th>
                      <th />
                    </tr>
                  </thead>
                  <VariantsTableBody {...props} />
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VariantsTable;
